export const templateComps = {
  confirmModal: {
    cancel: "Annuler",
    delete: "Supprimer",
  },
  channexIncident: {
    kicker: "Avis important",
    brandTitle: "Incident externe",
    closeLabel: "Fermer l'avis",
    subtitle:
      "Nous surveillons la situation et vérifierons la synchronisation une fois le service rétabli.",
    title:
      "Incident général de connexion avec Booking / Airbnb / channel manager externe",
    lead: "Bonjour, nous détectons un incident général avec notre fournisseur externe de synchronisation OTA.",
    text: "Cet incident affecte leur API et peut retarder la synchronisation des réservations, de la disponibilité et des fermetures de dates.",
    note: "Dès que la connexion sera rétablie, nous vérifierons la synchronisation des données pour contrôler les réservations, la disponibilité et les fermetures de dates.",
    textLast:
      "Chez WA Checkin, nous vérifierons la synchronisation une fois le service de nouveau opérationnel.",
    button: "J'ai compris",
  },
  notificationsNav: {
    title: "Notifications",
    recent: "récentes",
    emptyTitle: "Aucune notification",
    emptyText:
      "Lorsqu'un événement important concernant vos réservations se produira, il apparaîtra ici.",
    seeAll: "Voir toutes les notifications",
    meta: {
      t1: { status: "Nouvelle", category: "réservation" },
      t2: { status: "Mise à jour", category: "réservation" },
      t3: { status: "Annulée", category: "réservation" },
      t4: { status: "Terminé", category: "check-in" },
      t5: { status: "Demandé", category: "service" },
      t6: { status: "Reçue", category: "demande" },
      t7: { status: "Approuvée", category: "demande" },
      t8: { status: "Rejetée", category: "demande" },
      t9: { status: "Confirmé", category: "paiement" },
      t10: { status: "En attente de paiement", category: "paiement en attente" },
      t11: { status: "Attribuer une chambre", category: "réservation" },
      t12: { status: "Échec de l'envoi", category: "check-in" },
      t13: { status: "Non envoyé", category: "enregistrement des voyageurs" },
      t15: { status: "Actif", category: "abonnement" },
      default: { status: "Avis", category: "système" },
    },
    typeLabel: {
      t1: "NOUVELLE RÉSERVATION",
      t2: "RÉSERVATION MISE À JOUR",
      t3: "RÉSERVATION ANNULÉE",
      t4: "CHECK-IN",
      t5: "SERVICE",
      t6: "DEMANDE",
      t7: "DEMANDE APPROUVÉE",
      t8: "DEMANDE REJETÉE",
      t10: "EN ATTENTE DE PAIEMENT",
      t11: "ATTRIBUER UNE CHAMBRE",
      t12: "ÉCHEC DE L'ENVOI",
      t13: "ENREGISTREMENT DES VOYAGEURS",
      t15: "ABONNEMENT ACTIF",
      default: "NOTIFICATION",
    },
  },
};
